import { routes } from "constants/routes";
import Login from "containers/Auth/Login";
import PrivateRoutes from "containers/Auth/PrivateRoutes";
import VerifyAuth from "containers/Auth/VerifyAuth";
import ChooseBusiness from "containers/ChooseBusiness";
import Home from "containers/Home";
import OnboardingBusiness from "containers/OnboardingBusiness";
import SignUp from "containers/SignUp";
import ForgotPassword from "containers/ForgotPassword";
import PaymentMethodManagement from "containers/PaymentMethodManagement/PaymentMethodManagement";
import Purchase from "containers/Purcahase";
import TopupHistory from "containers/TopupHistory";
import TransactionStatus from "containers/TransactionStatus/TransactionStatus";
import SubscriptionTiers from "containers/SubscriptionTiers";
import InstantPay from "containers/InstantPay";
import ListBusiness from "containers/ListBusiness";
import Offers from "containers/Offers";
import DoubleUp from "containers/DoubleUp";

import { Route, Routes } from "react-router-dom";

const RootRoutes = () => {
  return (
    <Routes>
      {/* Protected Routes */}
      <Route element={<PrivateRoutes />}>
        <Route path={routes.home} element={<Home />} />
        <Route
          path={routes.onboardingBusiness}
          element={<OnboardingBusiness />}
        />
        <Route path={routes.topupHistory} element={<TopupHistory />} />
        <Route
          path={`${routes.chooseBusiness}/:businessId`}
          element={<ChooseBusiness />}
        />
        <Route path={routes.purchase} element={<Purchase />} />
        <Route
          path={routes.paymentManagement}
          element={<PaymentMethodManagement />}
        />
        <Route
          path={routes.transactionStatus}
          element={<TransactionStatus />}
        />
        <Route
          path={routes.subscriptionTiers}
          element={<SubscriptionTiers />}
        />
        <Route path={routes.instantPay} element={<InstantPay />} />
        <Route path={routes.listBusiness} element={<ListBusiness />} />
        <Route path={routes.offers} element={<Offers />} />
        <Route path={routes.doubleUp} element={<DoubleUp />} />
      </Route>
      {/* Pre-signin routes */}
      <Route path={routes.login} element={<Login />} />
      <Route path={routes.signUp} element={<SignUp />} />
      <Route path={routes.forgotPassword} element={<ForgotPassword />} />
      <Route path={routes.verifyAuth} element={<VerifyAuth />} />
    </Routes>
  );
};

export default RootRoutes;
